<template>
    <div>
        <template v-if="viewPage == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="viewPage == true">
        <div class="modal fade" id="singleStudent" tabindex="-1" aria-labelledby="singleStudent" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content p-3">
                    <div class="popup-head line-head">
                        <h2 class="pb-3"> Add New Student </h2>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                        <span>&times;</span>
                    </button>
                    <div class="modal-body p-0">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Student ID" v-model="studentForm.student_id"/>
                                    <has-error :form="studentForm" field="student_id"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Name"  v-model="studentForm.name"/>
                                    <has-error :form="studentForm" field="name"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="CNIC"  v-model="studentForm.cnic_number"/>
                                    <has-error :form="studentForm" field="cnic_number"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Mobile Number"  v-model="studentForm.mobile_number"/>
                                    <has-error :form="studentForm" field="mobile_number"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" required placeholder="Email"  v-model="studentForm.email_address"/>
                                    <has-error :form="studentForm" field="email_address"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 text-right">
                            <button class="btn btn-primary active" @click="addSingleStudent"> Save </button>
                            <button class="btn btn-primary" data-dismiss="modal" aria-hidden="true" aria-label="Close"> Cancel </button>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- Need Ateention Modal End -->
        <div class="modal fade" id="singleVoucher" tabindex="-1" aria-labelledby="singleVoucher" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content p-3">
                    <div class="popup-head line-head">
                        <h2 class="pb-3"> Add New Voucher </h2>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                        <span>&times;</span>
                    </button>
                    <div class="modal-body p-0">
                        <div class="row pt-1">
                            <div class="col-md-6">
                                <div class="form-group autocomplete">
                                    <input id="voucher_student_id" type="text" class="form-control" autocomplete="off" placeholder="Student ID *" v-model="voucherForm.student_id" :class="{ 'is-invalid': voucherForm.errors.has('student_id') }"/>
                                    <has-error :form="voucherForm" field="student_id"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input type="text" class="form-control" autocomplete="off" placeholder="Admission Fee"  v-model="voucherForm.admission_fee" :class="{ 'is-invalid': voucherForm.errors.has('admission_fee') }"/>
                                    <has-error :form="voucherForm" field="admission_fee"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <input type="text" class="form-control" autocomplete="off" placeholder="Registration Fee"  v-model="voucherForm.registration_fee" :class="{ 'is-invalid': voucherForm.errors.has('registration_fee') }"/>
                              <has-error :form="voucherForm" field="registration_fee"></has-error>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <input type="text" class="form-control" autocomplete="off" placeholder="Tuition Fee *"  v-model="voucherForm.tuition_fee" :class="{ 'is-invalid': voucherForm.errors.has('tuition_fee') }"/>
                              <has-error :form="voucherForm" field="tuition_fee"></has-error>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Security Charges"  v-model="voucherForm.security_charges" :class="{ 'is-invalid': voucherForm.errors.has('security_charges') }"/>
                                <has-error :form="voucherForm" field="security_charges"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Head Office Charges"  v-model="voucherForm.head_office_charges" :class="{ 'is-invalid': voucherForm.errors.has('head_office_charges') }"/>
                                <has-error :form="voucherForm" field="head_office_charges"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Annual Fund"  v-model="voucherForm.annual_fund" :class="{ 'is-invalid': voucherForm.errors.has('annual_fund') }"/>
                                <has-error :form="voucherForm" field="annual_fund"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Examination Charges"  v-model="voucherForm.examination_charges" :class="{ 'is-invalid': voucherForm.errors.has('examination_charges') }"/>
                                <has-error :form="voucherForm" field="examination_charges"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Transportation Charges"  v-model="voucherForm.transportation_charges" :class="{ 'is-invalid': voucherForm.errors.has('transportation_charges') }"/>
                                <has-error :form="voucherForm" field="transportation_charges"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Rent"  v-model="voucherForm.rent" :class="{ 'is-invalid': voucherForm.errors.has('rent') }"/>
                                <has-error :form="voucherForm" field="rent"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Fine"  v-model="voucherForm.fine" :class="{ 'is-invalid': voucherForm.errors.has('fine') }"/>
                                <has-error :form="voucherForm" field="fine"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                <input type="text" class="form-control" autocomplete="off" placeholder="Others"  v-model="voucherForm.others" :class="{ 'is-invalid': voucherForm.errors.has('others') }"/>
                                <has-error :form="voucherForm" field="others"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <select v-model="voucherForm.payment_type" name="payment_type" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': voucherForm.errors.has('payment_type') }">
                                        <option value="" selected>Select Payment Type *</option>
                                        <!-- <option value="1Bill">Fixed Payment</option> -->
                                        <option value="ibft">Partial Payment</option>
                                    </select>
                                    <has-error :form="voucherForm" field="payment_type"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group" :class="{ 'calendar-error': voucherForm.errors.has('due_date') }">
                                    <datepicker name="to" :bootstrap-styling="true" placeholder="Apply To *" v-model="voucherForm.due_date" :input-class="{ 'is-invalid datepicker': voucherForm.errors.has('due_date'), 'datepicker': !voucherForm.errors.has('due_date')}"></datepicker>
                                    <has-error :form="voucherForm" field="due_date"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 text-right">
                            <button class="btn btn-primary" data-dismiss="modal" aria-hidden="true" aria-label="Close"> Cancel </button>
                            <button class="btn btn-primary active" @click="addSingleVoucher" id="save-voucher"> Save </button>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- Need Ateention Modal End -->
        <div class="modal fade" id="employeeEdit" tabindex="-1" role="dialog" aria-labelledby="employeeEditLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body p-4">
                        <form @submit.prevent="editCampusData">
                            <div class="tab-content-inner">
                                <div class="form-group">
                                    <label>Type <em class="required">*</em></label>
                                    <select v-model="form.campus_type" name="campus_type" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('campus_type') }">
                                        <option value="" selected>Select Type</option>
                                        <option value="OWNED">Owned</option>
                                        <option value="FRANCHISE">Franchise</option>
                                    </select>
                                    <has-error :form="form" field="campus_type"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Name <em class="required">*</em></label>
                                    <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Code <em class="required">*</em></label>
                                    <input v-model="form.campus_code" type="text" name="campus_code" class="form-control" :class="{ 'is-invalid': form.errors.has('campus_code') }">
                                    <has-error :form="form" field="campus_code"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> City <em class="required">*</em></label>
                                    <select v-model="form.city_id" name="city_id" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('city_id') }">
                                        <option value="" selected>Select City</option>
                                        <option v-for="city in this.campus.cities" :key="city.id" :value="city.id">{{city.name}}</option>
                                    </select>
                                    <has-error :form="form" field="status"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Address <em class="required">*</em></label>
                                    <textarea v-model="form.address" name="address" class="form-control" :class="{ 'is-invalid': form.errors.has('address') }"></textarea>
                                    <has-error :form="form" field="address"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Status <em class="required">*</em></label>
                                    <select v-model="form.status" name="status" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                                        <option value="" selected>Select Status</option>
                                        <option value="ENABLED">Enabled</option>
                                        <option value="DISABLED">Disabled</option>
                                    </select>
                                    <has-error :form="form" field="status"></has-error>
                                </div>
                            </div>
                            <div class="form-group">
                                <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                <router-link to="/companies" class="btn btn-primary float-right mr-2">Cancel</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
		<div class="page-top branch-detail-top mb-1 mb-3 clearfix">
			<h1 class="float-left mt-2"> Branch Detail </h1>
			<a href="#" class="btn btn-primary float-right ml-1 active-branch-btn"> {{this.campus.status}} </a>
			<a href="#" class="btn btn-primary float-right"> {{this.campus.campus_type}} </a>
		</div>
		<div class="collections-tabs mb-4">
			<ul class="nav nav-tabs nav-tabs-2" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" id="branch-details-tab" data-toggle="tab" href="#branch-details" role="tab" aria-controls="branch-details" aria-selected="true">Detail</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" id="students-tab" data-toggle="tab" href="#students" role="tab" aria-controls="students" aria-selected="false">Students</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" id="vouchers-tab" data-toggle="tab" href="#voucher-section" role="tab" aria-controls="voucher-section" aria-selected="false">Vouchers</a>
				</li>
			</ul>
		</div>
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="branch-details" role="tabpanel" aria-labelledby="branch-details-tab">
				<div class="pm-employee-view-main branch-detail-main-sec">
					<div class="row">
						<div class="col-md-8">
							<label class="label block-label highlight-color mb-3 clearfix">
								<span class="highlight-color float-left"> Campus/Branch Detail </span>
								<a href="#" class="float-right"  data-toggle="modal" data-target="#employeeEdit"> <i class="fas fa-pencil-alt"></i> </a>
							</label>
							<div class="pm-employee-detail-box mb-3">
								<div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Name: </strong> </div>
									<div class="col-md-8"> <p> {{this.campus.name}} </p> </div>
								</div>
								<div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Code:  </strong> </div>
									<div class="col-md-8"> <p> {{this.campus.campus_code}} </p> </div>
								</div>
								<div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Type: </strong> </div>
									<div class="col-md-8"> <p> {{this.campus.campus_type}} </p> </div>
								</div>
								<div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Address:  </strong> </div>
									<div class="col-md-8"> <p> {{this.campus.address}} </p> </div>
								</div>
							</div>
						</div>
						<div class="col-md-4">
							<div class="branch-detail-right-box">
								<h2 class="mb-2"> Campus/Branch Actions </h2>
								<ul>
									<li> <a href="#" data-toggle="modal" data-target="#singleStudent" > Add New students  </a> </li>
									<li> <a href="#" data-toggle="modal" data-target="#singleVoucher" > Generate New Voucher </a> </li>
									<li> <a @click="removeCampusByid()"> Remove Campus/Branch </a> </li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pane fade" id="students" role="tabpanel" aria-labelledby="students-tab">
				<div class="pm-employee-view-main branch-detail-main-sec">
					<div class="row">
						<div class="col-md-8">
							<div class="table-holder">
								<table class="table">
									<thead>
										<tr>
											<th>Student Name</th>
											<th>CNIC</th>
											<th>Mobile Number</th>
											<th class="text-center">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="student in this.campus.student_profile" :key="student.id">
											<td>{{student.name}} <span class="id"> ID: {{student.student_id}} </span></td>
											<td>{{student.cnic_number}}</td>
											<td>{{student.mobile_number}}</td>
											<td class="text-center">
												<a @click="deleteStudents(student.id)" data-toggle="tooltip" data-placement="top" title="Delete" class="action view"> <i class="fas fa-trash"></i> </a>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="col-md-4">
							<div class="branch-detail-right-box mt-0">
								<h2 class="mb-2"> Branch Actions </h2>
								<ul>
									<li> <a href="#" data-toggle="modal" data-target="#singleStudent" > Add New students  </a> </li>
									<li> <a href="#" data-toggle="modal" data-target="#singleVoucher" > Generate New Voucher </a> </li>
									<li> <a @click="removeCampusByid()"> Remove Campus/Branch </a> </li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pane fade" id="voucher-section" role="tabpanel" aria-labelledby="vouchers-tab">
				<div class="pm-employee-view-main branch-detail-main-sec">
					<div class="row">
						<div class="col-md-8">
							<div class="table-holder">
								<table class="table">
									<thead>
										<tr>
											<th>Date</th>
											<th>Voucer ID</th>
											<th>Student</th>
											<th class="text-center">Actions</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="voucher  in this.campus.fee_vouchers" :key="voucher.id">
											<td>{{voucher.created_at}}</td>
											<td>{{voucher.unique_identifier}}</td>
											<td>{{voucher.name}}</td>
											<td class="text-center">
												<a href="#" data-toggle="tooltip" data-placement="top" title="Delete" class="action view"> <i class="fas fa-trash"></i> </a>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
						<div class="col-md-4">
							<div class="branch-detail-right-box mt-0">
								<h2 class="mb-2"> Branch Actions </h2>
								<ul>
									<li> <a href="#" data-toggle="modal" data-target="#singleStudent" > Add New students  </a> </li>
									<li> <a href="#" data-toggle="modal" data-target="#singleVoucher" > Generate New Voucher </a> </li>
									<li> <a @click="removeCampusByid()"> Remove Campus/Branch </a> </li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                voucherForm : new Form({
                  campus_id : this.$route.params.id,
                    student_id : '',
                  admission_fee : null,
                  registration_fee : null,
                  tuition_fee : '',
                  security_charges : null,
                  head_office_charges : null,
                  annual_fund : null,
                  examination_charges : null,
                  transportation_charges : null,
                  rent : null,
                  fine : null,
                  others : null,
                  due_date : '',
                  payment_type: ''
                }),
                studentForm: new Form({
                    campus_id : this.$route.params.id,
                    student_id : '',
                    name : '',
                    cnic_number : '',
                    mobile_number : '',
                    email_address : '',
                }),
                form: new Form({
                    id : '',
                    campus_type : '',
                    city_id : '',
                    name : '',
                    campus_code : '',
                    address : '',
                    status : '',
                }),
                campus : null,
                viewPage : null,
            }
        },
        methods: {
            addSingleStudent() {
                this.$Progress.start();
                this.studentForm.post('/api/feeAddStudent')
                .then(res => {
                  if(res.status=200){
                      if(res.data.code == 400 ){
                        this.$Progress.fail();
                        this.showAlertBox('error',res.data.msg);
                      }else{
                        this.$Progress.finish();
                        this.showToastBox('success','Student created successfully');
                        this.$router.go();
                      }
                  }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                  }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in you form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            addSingleVoucher() {
                this.$Progress.start();
                this.disableButton('save-voucher','Submitting…',true);
                this.voucherForm.post('/api/feeAddVoucher')
                .then(res => {
                  if(res.status=200){
                      if(res.data.code == 400 ){
                        this.disableButton('save-voucher','Save',false);
                        //this.showToastBox('error','Voucher has not been created, Please try again');
                        this.showToastBox('error',res.data.msg);
                      }else{
                        this.$Progress.finish();
                        this.showToastBox('success','Voucher created successfully');
                        this.$router.go();
                      }
                      this.disableButton('save-voucher','Save',false);
                      this.$Progress.finish();
                  }else{
                      this.disableButton('save-voucher','Save',false);
                      this.$Progress.fail();
                  }
                })
                .catch(err => {
                    console.log(err);
                    this.disableButton('save-voucher','Save',false);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in you form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
            removeCampusByid(){
                this.$Progress.start();
                axios.get('/api/deleteCampusById/'+this.$route.params.id)
                .then(result => {
                    console.log(result);
                    if(result.status == 200){
                        if(result.data.code == 200){
                            this.showToastBox('success','Campus has been deleted');
                            this.$router.push('/feeCampus');
                        }else{
                            this.showToastBox('error','Error in deleting campus');
                        }
                    }
                    this.$Progress.finish();
                })
                .catch(error => {
                    this.$Progress.fail();
                });
            },
            deleteStudents(id){
                this.$Progress.start();
                axios.get('/api/deleteStudentById/'+id)
                .then(result => {
                    console.log(result);
                    if(result.status == 200){
                        if(result.data.code == 200){
                            this.showToastBox('success','Student has been deleted');
                            this.$router.go();
                        }else{
                            this.showToastBox('error','Error in deleting student');
                        }
                    }
                    this.$Progress.finish();
                })
                .catch(error => {
                    this.$Progress.fail();
                });
            },
            editCampusData() {
                this.$Progress.start();
                this.form.put('/api/updateFeeCampus')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Campus/Branch updated successfully');
                        this.$router.go();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in you form data');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                });
            },
        },
        created() {
            this.$Progress.start();
            axios.get('/api/editFeeCampus/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.viewPage = res.data.viewPage;
                        this.campus = res.data;
                        this.form.id = res.data.id;
                        this.form.campus_type = res.data.campus_type;
                        this.form.city_id = res.data.city_id;
                        this.form.name = res.data.name;
                        this.form.campus_code = res.data.campus_code;
                        this.form.address = res.data.address;
                        this.form.status = res.data.status;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
            }).then(res =>{
                $(this.$el).find('.selectpicker').selectpicker('refresh');
            })
            .catch(err => {
                console.log(err);
                this.$Progress.fail();
                this.showAlertBox('error','Error to load form data');
            });
        }
    }
</script>
